const TrashIcon = () => {
  return (
    <>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1"
          y="1"
          width="42"
          height="42"
          rx="11"
          stroke="#E50300"
          stroke-width="2"
        />
        <path
          d="M29 14H25.5L24.5 13H19.5L18.5 14H15V16H29M16 29C16 29.5304 16.2107 30.0391 16.5858 30.4142C16.9609 30.7893 17.4696 31 18 31H26C26.5304 31 27.0391 30.7893 27.4142 30.4142C27.7893 30.0391 28 29.5304 28 29V17H16V29Z"
          fill="#E92220"
        />
      </svg>
    </>
  );
};
export default TrashIcon;
